module.exports = "/_next/static/images/Matt_Lutton-3d213c7cc83761b02c861e1c30905ba2.webp";